import { h } from 'preact';
import { SelectEntry } from '../entries/SelectEntry';

const getComplexTypes = (i18n) => [
  { value: '', label: i18n['opt.none'] || '-- None --' },
  { value: 'SignTogether', label: i18n['opt.SignTogether'] || 'Sign Together' },
  { value: 'SignForward', label: i18n['opt.SignForward'] || 'Sign Forward' },
  { value: 'SignInOrder', label: i18n['opt.SignInOrder'] || 'Sign In Order' },
];

const getMergeTypes = (i18n) => [
  { value: '', label: i18n['opt.none'] || '-- None --' },
  { value: 'sequence', label: i18n['opt.sequence'] || 'Sequence' },
  { value: 'parallel', label: i18n['opt.parallel'] || 'Parallel' },
  { value: 'any', label: i18n['opt.any'] || 'Any' },
];

const getCompareTypes = (i18n) => [
  { value: '', label: i18n['opt.none'] || '-- None --' },
  { value: 'count', label: i18n['opt.count'] || 'Count' },
  { value: 'percentage', label: i18n['opt.percentage'] || 'Percentage' },
];

const TASK_TYPES = ['epx:UserTask', 'epx:ManualTask'];

export class MultiSignPropertiesProvider {
  constructor(lf, i18n) {
    this._lf = lf;
    this._i18n = i18n;
  }

  isApplicable(elementType) {
    return TASK_TYPES.includes(elementType);
  }

  getGroups(element) {
    const { lf, i18n } = { lf: this._lf, i18n: this._i18n };
    const props = element.properties || {};
    const id = element.id;

    const update = (key, value) => {
      lf.setProperties(id, { [key]: value });
      lf.emit('node:properties-change', { id, properties: { [key]: value } });
    };

    return [
      {
        id: 'multiSign',
        label: i18n.multiSign || 'Multi-Sign',
        entries: [
          {
            id: 'complexType',
            component: () => (
              <SelectEntry
                id="epx-complexType"
                label={i18n.complexType || 'Complex Type'}
                value={props.complexType || ''}
                options={getComplexTypes(i18n)}
                onChange={(val) => update('complexType', val)}
              />
            ),
          },
          {
            id: 'mergeType',
            component: () => (
              <SelectEntry
                id="epx-mergeType"
                label={i18n.mergeType || 'Merge Type'}
                value={props.mergeType || ''}
                options={getMergeTypes(i18n)}
                onChange={(val) => update('mergeType', val)}
              />
            ),
          },
          {
            id: 'compareType',
            component: () => (
              <SelectEntry
                id="epx-compareType"
                label={i18n.compareType || 'Compare Type'}
                value={props.compareType || ''}
                options={getCompareTypes(i18n)}
                onChange={(val) => update('compareType', val)}
              />
            ),
          },
          {
            id: 'completeOrder',
            component: () => (
              <SelectEntry
                id="epx-completeOrder"
                label={i18n.completeOrder || 'Complete Order'}
                value={props.completeOrder || ''}
                options={[
                  { value: '', label: i18n['opt.none'] || '-- None --' },
                  { value: 'sequential', label: i18n['opt.sequential'] || 'Sequential' },
                  { value: 'parallel', label: i18n['opt.parallel'] || 'Parallel' },
                ]}
                onChange={(val) => update('completeOrder', val)}
              />
            ),
          },
        ],
      },
    ];
  }
}
